;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { TEAM_ROLE_IDS } from '@workspace/ui/lib';
import type { UserVerificationOrganization } from '@/types/user';

export const ORGANISATION_SWITCHER_SECTION_LABEL = 'Switch company and role';

export interface OrganisationSwitcherItem {
  key: string;
  organisationId: number;
  organisationName: string;
  roleContext: string;
  subtitle: string;
}

export function formatRoleContextLabel(roleContext: string): string {
  return roleContext
    .split('_')
    .filter(Boolean)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase())
    .join(' ');
}

function getPersonalTeamRoleLabel(roles: string[]): string | null {
  if (roles.includes(TEAM_ROLE_IDS.GLOBAL_ADMIN)) {
    return 'Global admin';
  }

  if (roles.includes(TEAM_ROLE_IDS.TEAM_LEAD)) {
    return 'Team lead';
  }

  return null;
}

export function formatOrganisationSwitcherSubtitle(
  roleContext: string,
  roles: string[] | undefined
): string {
  const contextLabel = roleContext ? formatRoleContextLabel(roleContext) : '';
  const teamRoleLabel = getPersonalTeamRoleLabel(roles ?? []);

  if (contextLabel && teamRoleLabel) {
    return `${contextLabel} • Personal/${teamRoleLabel}`;
  }

  return contextLabel;
}

export function buildOrganisationSwitcherItems(
  organisations: UserVerificationOrganization[]
): OrganisationSwitcherItem[] {
  return organisations.flatMap((organisation) => {
    const roleContexts =
      organisation.role_contexts && organisation.role_contexts.length > 0
        ? organisation.role_contexts
        : [''];

    return roleContexts.map((roleContext) => ({
      key: roleContext ? `${organisation.id}-${roleContext}` : String(organisation.id),
      organisationId: organisation.id,
      organisationName: organisation.name,
      roleContext,
      subtitle: formatOrganisationSwitcherSubtitle(roleContext, organisation.roles),
    }));
  });
}

/** Label for the switch confirmation dialog (Figma “view name”). */
export function getOrganisationSwitchViewName(item: OrganisationSwitcherItem): string {
  if (item.subtitle) {
    return `${item.organisationName} · ${item.subtitle}`;
  }

  const roleLabel = item.roleContext ? formatRoleContextLabel(item.roleContext) : '';
  if (roleLabel) {
    return `${item.organisationName} · ${roleLabel}`;
  }

  return item.organisationName;
}

export function isOrganisationSwitcherItemActive(
  item: OrganisationSwitcherItem,
  activeOrganisationId: number | undefined,
  activeRoleContext: string | undefined
): boolean {
  if (item.organisationId !== activeOrganisationId) {
    return false;
  }

  if (!item.roleContext) {
    return true;
  }

  if (!activeRoleContext) {
    return false;
  }

  return item.roleContext === activeRoleContext;
}
